<div>
    <app-spinner [state]="loading"></app-spinner>
    <app-toastr [properties]="alertProperties" *ngIf="showAlert"></app-toastr>
    <div class="card">
        <form [formGroup]="editForm">
            <div class="form_container mb-0">
                <div>
                    <app-accordion [defaultExpand]="true" [properties]="{header: 'Basic Details'}"
                        [template]="BasicDetailSection">
                        <ng-template #BasicDetailSection>
                            <div class="pt-3">
                                <div class="row align-items-center">
                                    <div class="col-md-3 d-flex flex-column align-items-center">
                                        <div class="profile-image-container">
                                            <img [src]="profileImageBase64" *ngIf="profileImageBase64" alt="Profile Image" class="profile-image">
                                        </div>
                                        <button *ngIf="isEditMode" class="change-photo-btn" (click)="triggerFileInput()">Change Photo</button>
                                        <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="row">
                                            <div class="col-6 mb-2">
                                                <label class="label fw-bold">First Name<span *ngIf="isEditMode" class="required">*</span></label>
                                                <p *ngIf="!isEditMode">{{userDetail?.firstName}}</p>
                                                <app-text-field *ngIf="isEditMode" [control]="$any(editForm.get('firstName'))" [submitted]="submitted"
                                                    [placeholder]="'First Name'" [errorMessage]="'First Name is required'"></app-text-field>
                                            </div>
                                            <div class="col-6 mb-2">
                                                <label class="label fw-bold">Last Name<span *ngIf="isEditMode" class="required">*</span></label>
                                                <p *ngIf="!isEditMode">{{userDetail?.lastName}}</p>
                                                <app-text-field *ngIf="isEditMode" [control]="$any(editForm.get('lastName'))" [submitted]="submitted"
                                                    [placeholder]="'Last Name'" [errorMessage]="'Last Name is required'"></app-text-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </app-accordion>
                </div>
                <div style="margin-top: 20px;">
                    <app-accordion [defaultExpand]="true" [properties]="{header: 'Contact Details'}"
                        [template]="ContactDetailSection">
                        <ng-template #ContactDetailSection>
                            <div class="pt-3">
                                <div class="row">
                                    <div class="col-6 mb-2">
                                        <label class="label fw-bold">e-Mail<span *ngIf="isEditMode"
                                                class="required">*</span></label>
                                        <p *ngIf="!isEditMode">{{userDetail?.email}}</p>
                                        <app-text-field *ngIf="isEditMode" [control]="$any(editForm.get('email'))"
                                            [submitted]="submitted" [placeholder]="'Email Address'"
                                            [errorMessage]="'Email is required'"></app-text-field>
                                    </div>
                                    <div class="col-6 mb-2">
                                        <label class="label fw-bold">Phone Number<span *ngIf="isEditMode"
                                                class="required">*</span></label>
                                        <p *ngIf="!isEditMode">{{userDetail?.phoneNumber}}</p>
                                        <app-text-field *ngIf="isEditMode" [control]="$any(editForm.get('phoneNumber'))"
                                            [submitted]="submitted" [placeholder]="'Phone Number'" [type]="'tel'"
                                            [errorMessage]="'Phone Number is required'"></app-text-field>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </app-accordion>
                </div>
                <div style="margin-top: 20px;">
                    <app-accordion [defaultExpand]="true" [properties]="{header: 'Permission Details'}"
                        [template]="RoleDetailSection">
                        <ng-template #RoleDetailSection>
                            <div class="pt-3">
                                <div class="row">
                                    <div class="col-4 mb-2">
                                        <label class="label fw-bold">Role<span class="required">*</span>
                                        </label><p><span *ngFor="let role of userDetail?.userRoles; let i = index">
                                            {{role?.refRole?.name}}<span
                                            *ngIf="i !== userDetail?.userRoles.length - 1">, </span>
                                        </span></p>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </app-accordion>
                </div>
                <div style="margin-top: 20px;">
                    <app-accordion [defaultExpand]="true" [properties]="{header: 'Change Password'}"
                        [template]="ChangePasswordSection">
                        <ng-template #ChangePasswordSection>
                            <div class="pt-3" *ngIf="isEditMode">
                                <div class="row">
                                    <div class="col-6 mb-2">
                                        <label class="label fw-bold">New Password</label>
                                        <app-text-field [control]="$any(editForm.get('newPass'))"
                                            [submitted]="submitted" [placeholder]="'New Password'"
                                            [errorMessage]="'New Password is required'"></app-text-field>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </app-accordion>
                </div>
                <div style="margin-top: 20px;">
                    <div class="d-flex justify-content-end">
                        <app-button *ngIf="!isEditMode" [properties]="{name:'Edit', type: 'primary'}"
                            (click)="onEdit()"></app-button>
                        <app-button *ngIf="isEditMode" [properties]="{name:'Cancel', type: 'secondary'}"
                            (click)="onCancel()"></app-button>
                        <app-button *ngIf="isEditMode" [properties]="{name:'Update', type: 'primary'}"
                            (click)="onSave()"></app-button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<app-modal [template]="modalTemplate" [state]="modalState" [size]="modalSize"></app-modal>
<ng-template #saveTemplateHeader>
    <h4>Update Details</h4>
</ng-template>
<ng-template #saveTemplateBody>
    <p>Are you sure to update the user details?</p>
</ng-template>
<ng-template #saveTemplateFooter>
    <app-button [properties]="{name:'Cancel', type:'secondary'}" (click)="onCloseModal()"></app-button>
    <app-button [properties]="{name:'Update', type:'primary'}" (click)="updateUser()"></app-button>
</ng-template>